import { appFetch } from "./config";

export const resetPassword = async (email: string) => {
  const response: Response = await appFetch("account/reset-password", {
    method: "POST",
    body: JSON.stringify({ email }),
  });
  return response.json();
};
